import React from "react";
import classnames from "classnames";
import styles from "./Align.module.scss";

type Props = {
  direction?: "left" | "center" | "right";
  component?: React.ElementType;
  children: React.ReactNode;
  className?: string;
  method?: "text" | "flex";
};

const Align = ({
  direction = "center",
  component: Component = "div",
  children,
  className,
  method = "text"
}: Props) => {
  return (
    <Component
      className={classnames(
        styles["Align"],
        styles[`Align--${direction}`],
        className,
        {
          [styles["Align--flex"]]: method === "flex"
        }
      )}
    >
      {children}
    </Component>
  );
};

export default Align;
